<template>
  <div class="page4">
    <div class="bottom"></div>
    <div class="main">
      <div class="bg"></div>
      <img @click="jump" class="back" src="../../static/img/back.png" alt="" />
      <img class="pic" src="../../static/img/hpjmt.png" alt="" />
      <img class="name" src="../../static/img/hpjmt-tl.png" alt="" />
      <div class="word">
        <div>
          最近《江苏省国民经济和社会发展第十四个五年规划和二〇三五年远景目标纲要》正式发布。其中，苏申内港线（即吴淞江）等四条水运“动脉”的整治提升工程列入了省十四五规划纲要，这意味着，苏沪之间物流的“一江春水”将更加通畅，两地的“同城效应”进一步凸显。
        </div>
        <div>
          目前，园区港的外贸航线主要前往上海外高桥码头，但这只是第一步，更重要的是前往洋山港。外高桥码头以近洋航线为主，船主要前往日韩、东南亚、中国台湾等国家和地区，洋山港码头以远洋航线为主，船主要前往欧美等地区，而园区企业的产品更多的是运往欧美地区。对此，园区港将抢抓吴淞江航道整治、进一步完善水路运输体系的机遇，实现与长三角一线港口的全面互通。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    jump() {
      this.$router.push("/page1");
    },
  },
  mounted() {
    let Main = document.querySelector(".main");
    let MainW = Main.getBoundingClientRect().width;
    Main.style.height = (MainW / 750) * 1500 + "px";
  },
};
</script>

<style scoped>
.page4 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.page4 .bottom{
  position:absolute;
  width:100%;
  height:100%;
  top:0;
  left:0;
  background: #89d7c6;
  opacity:0.5;
}
.page4 .main {
  position: absolute;
  left: 0;
  top: -100%;
  bottom: -100%;
  margin: auto;
  width: 100%;
  height: auto;
}
.page4 .bg {
 position: absolute;
  /* width: 50%;
  height: 50%;
  background: url("../../static/img/page2-bg.jpg");
  background-size: 100% 100%;
  top:calc((100vh - 50%) / 2);
  left:calc((100vw - 50%) / 2); 
  animation: bgdh 0.5s ease-out 1;
  animation-fill-mode: forwards; */
   width: 100%;
   height: 100%;
   background: url("../../static/img/page2-bg.jpg");
   background-size: 100% 100%;
   border-radius: 50%;
   transform: scale(0.2);
   animation: bgdh 0.5s linear 1;
   animation-fill-mode: forwards;
}
.back {
  width: 10.13%;
  position: absolute;
  top: 71%;
  left: 10%;
  opacity:0;
  animation: show 2s 0.5s linear 1;
  animation-fill-mode: forwards;
}
.pic {
  width: 52.19%;
  position: absolute;
  top: 13%;
  left: 17%;
  opacity: 0;
  animation: show 2s 1.5s linear 1;
  animation-fill-mode: forwards;
}
.name {
   width: 13.07%;
  position: absolute;
  top: 11%;
  left: 74%;
  opacity:0;
  animation: show 2s 0.5s linear 1;
  animation-fill-mode: forwards;
}
.word {
  width: 67%;
  height: 24%;
  position: absolute;
  left: 16%;
  top: 61%;
  transform:rotateZ(90deg);
  /* background:gray; */
  overflow: auto;
  color: #17848b;
  text-indent: 42px;
  line-height: 28px;
  letter-spacing: 5px;
  opacity: 0;
  animation: show 2s 2s linear 1;
  animation-fill-mode: forwards;
}
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/* @keyframes bgdh {
  0%{
    width: 50%;
    height: 50%;
    border-radius: 50%;
    opacity:0;
    top:calc((100vh - 50%) / 2);
    left:calc((100vw - 50%) / 2);
  }
  100%{
    width: 100%;
    height: 100%;
    border-radius: 0;
    top:0;
    left:0;
    opacity:1;
  }
} */
@keyframes bgdh {
  0%{
    border-radius: 50%;
    transform: scale(0.2)
  }
  100%{
    border-radius: 0 ;
    transform: scale(1)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page4.vue